export enum PaymentProcessingViewState {
    BUY = "BUY",
    NOT_ENOUGH_TOKENS = "NOT ENOUGH TOKENS",
    PAYMENT_PROCESSING = "PAYMENT PROCESSING"
}